import React, { forwardRef } from 'react';

interface VideoElementProps {
  src: string;
  fileType?: 'video' | 'image';
  poster?: string;
  isDrawingEnabled: boolean;
  isDrawingToolboxOpen?: boolean;
  /** Görsel: viewport içi sabit çizim boyutu (px); yoksa alanı doldurur */
  imageDisplaySize?: { width: number; height: number } | null;
  onTimeUpdate: () => void;
  onLoadedMetadata: () => void;
  onEnded: () => void;
  onVideoClick: (e: React.MouseEvent) => void;
  onError: (e: React.SyntheticEvent<HTMLVideoElement | HTMLImageElement, Event>) => void;
}

const VideoElement = forwardRef<HTMLVideoElement | HTMLImageElement, VideoElementProps>(({
  src,
  fileType = 'video',
  poster,
  isDrawingEnabled,
  isDrawingToolboxOpen = false,
  imageDisplaySize = null,
  onTimeUpdate,
  onLoadedMetadata,
  onEnded,
  onVideoClick,
  onError,
}, ref) => {
  const drawCursor = isDrawingEnabled && isDrawingToolboxOpen;
  if (fileType === 'image') {
    const sized =
      imageDisplaySize &&
      imageDisplaySize.width > 0 &&
      imageDisplaySize.height > 0;
    return (
      <img
        ref={ref as React.Ref<HTMLImageElement>}
        src={src}
        alt="Drawing canvas background"
        onClick={onVideoClick}
        onLoad={onLoadedMetadata}
        style={
          sized
            ? {
                display: 'block',
                width: `${imageDisplaySize!.width}px`,
                height: `${imageDisplaySize!.height}px`,
                cursor: drawCursor ? 'crosshair' : 'pointer',
                objectFit: 'contain',
              }
            : {
                display: 'block',
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                cursor: drawCursor ? 'crosshair' : 'pointer',
                objectFit: 'contain',
              }
        }
        onError={onError}
      />
    );
  }

  return (
    <video
      ref={ref as React.Ref<HTMLVideoElement>}
      src={src}
      poster={poster}
      onTimeUpdate={onTimeUpdate}
      onLoadedMetadata={onLoadedMetadata}
      onEnded={onEnded}
      onClick={onVideoClick}
      style={{ 
        width: '100%', 
        height: '100%',
        cursor: drawCursor ? 'crosshair' : 'pointer',
        backgroundColor: '#000',
        objectFit: 'contain',
      }}
      onError={onError}
      controls={false}
      preload="metadata"
      playsInline
      {...({ 'webkit-playsinline': 'true' } as any)}
    />
  );
});

VideoElement.displayName = 'VideoElement';

export default VideoElement; 